import { render } from "./SearchComp.vue?vue&type=template&id=5f663b64&scoped=true"
import script from "./SearchComp.vue?vue&type=script&lang=js"
export * from "./SearchComp.vue?vue&type=script&lang=js"

import "./SearchComp.vue?vue&type=style&index=0&id=5f663b64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f663b64"]])

export default __exports__